<script lang="ts" setup>
import { ref, watch } from 'vue'
import { useUserSettingsStore } from '@/stores/userSettings'
import NavigationItems from './NavigationItems.vue'
const userSettingsStore = useUserSettingsStore()
const theme = ref(userSettingsStore.theme)
watch(
  () => userSettingsStore.theme,
  (newValue) => (theme.value = newValue),
)
</script>

<template>
  <footer class="flex h-15 items-center border-t bg-white px-4 dark:bg-gray-800">
    <div class="flex flex-1 items-center justify-around">
      <NavigationItems />
    </div>
  </footer>
</template>
